"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosCustomerBlendHistorySchema = exports.APosCustomerBlendHistoryFulfillmentModeSchema = void 0;
const zod_1 = require("zod");
const id_schema_1 = require("../../common/id.schema");
/**
 * Module 29 — Oil Blending
 * CustomerBlendHistory — one row per blend sale to a customer.
 * PK = `${tenantId}#${customerId}`, SK = `${purchaseDate}#${saleId}`.
 * GSI: blend-index (tenantId + blend_recipe_id) — find all customers who bought a recipe.
 */
const decimal3dp = (val) => Number.isFinite(val) && Math.round(val * 1000) / 1000 === val;
exports.APosCustomerBlendHistoryFulfillmentModeSchema = zod_1.z.enum([
    'new_bottle', 'refill_own_bottle',
]);
exports.APosCustomerBlendHistorySchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    customerId: id_schema_1.EntityIdSchema,
    purchaseDate: zod_1.z.string().describe('ISO date — component of sort key'),
    saleId: id_schema_1.EntityIdSchema.describe('FK to canonical order/transaction id'),
    blend_recipe_id: id_schema_1.EntityIdSchema,
    lineId: zod_1.z.string().min(1).describe('Composite line id from the order'),
    bottle_size_ml: zod_1.z.number().positive().refine(decimal3dp, 'must be 3dp'),
    price_paid_cents: zod_1.z.number().int().nonnegative(),
    staff_id: id_schema_1.EntityIdSchema,
    rating: zod_1.z.number().int().min(1).max(5).optional(),
    fulfillmentMode: exports.APosCustomerBlendHistoryFulfillmentModeSchema,
    customerOwnedBottleId: id_schema_1.EntityIdSchema.optional(),
});
//# sourceMappingURL=customer-blend-history.schema.js.map